import ProvidersContainer from './ProvidersContainer';

export default ProvidersContainer;
